import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import VueJwtDecode from "vue-jwt-decode";

// CLIENT PAGES
import Dashboard from "../views/pages/Dashboard.vue";
import Mention from "../views/pages/Mention.vue";
import Hoax from "../views/pages/Hoax.vue";
import Sources from "../views/pages/Sources.vue";
import Search from "../views/pages/Search.vue";
import NewsTrend from "../views/pages/NewsTrend.vue";
import NewsTrendDetail from "../views/pages/NewsTrendDetail.vue";
import DataCleansing from "../views/pages/DataCleansing.vue";
import HistoryDataCleansing from "../views/pages/HistoryDataCleansing.vue";
import General from "../views/pages/analytics/General.vue";
import Maps from "../views/pages/analytics/Maps.vue";
import Narasumber from "../views/pages/analytics/Narasumber.vue";
import TrashBin from "../views/pages/TrashBin.vue";
import Keyword from "../views/pages/settings/Keyword.vue";
import Users from "../views/pages/settings/User.vue";
import Channel from "../views/pages/settings/Channel.vue";
import Media from "../views/pages/settings/Media.vue";
import Crawl from "../views/pages/settings/Crawl.vue";
import Profile from "../views/pages/Profile.vue";
import DetailAkun from "../views/pages/DetailAkun.vue";
import View from "../views/pages/View.vue";
import SNA from "../views/pages/analytics/SNA.vue";
import BotDetection from "../views/pages/analytics/BotDetection.vue";
import Top10Mentions from "../views/pages/analytics/Top10Mentions.vue";
import QuoteExtraction from "../views/pages/analytics/QuoteExtraction.vue";
import MediaTendency from "../views/pages/analytics/MediaTendency.vue";
import Trustmetter from "../views/pages/analytics/Trustmetter.vue";
import Trendinganalysis from "../views/pages/analytics/Trendinganalysis.vue";
import AccountIntegrity from "../views/pages/analytics/AccountIntegrity.vue";

import TwitterTrending from "../views/pages/TwitterTrending.vue";
import GoogleTrending from "../views/pages/GoogleTrending.vue";

// MAIN LAYOUT
import MainLayout from "../views/layout/main.vue";
import NoAUthMainLayout from "../views/layout/noauth/main.vue";
import Login from "../views/pages/Login.vue";
import PageNotFound from "../views/pages/Error404.vue";

Vue.use(VueRouter);

const routes = [
  // CLIENT ROUTES
  {
    path: "/",
    name: "Layout",
    component: MainLayout,
    redirect: "/dashboard",
    _children: [
      // DASHBOARD
      {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // MENTIONS
      {
        path: "/posts",
        name: "Posts",
        component: Mention,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // HOAX
      {
        path: "/hoax",
        name: "Hoax",
        component: Hoax,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SOURCE
      {
        path: "/sources",
        name: "Sources",
        component: Sources,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SEARCH
      {
        path: "/search",
        name: "Search",
        component: Search,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // NEWS TREND
      {
        path: "/newstrend",
        name: "NewsTrend",
        component: NewsTrend,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // DETAIL NEWS TREND
      {
        path: "/newstrend/detail",
        name: "NewsTrendDetail",
        component: NewsTrendDetail,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // DATA CLEANSING
      {
        path: "/cleansing",
        name: "Cleansing",
        component: DataCleansing,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // HISTORY DATA CLEANSING
      {
        path: "/history-cleansing",
        name: "HistoryDataCleansing",
        component: HistoryDataCleansing,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS GENERAL
      {
        path: "/analytics",
        name: "General",
        component: General,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS MAP
      {
        path: "/maps",
        name: "Maps",
        component: Maps,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS SNA
      {
        path: "/sna",
        name: "SNA",
        component: SNA,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS MEDIA TENDENCY
      {
        path: "/media-tendency",
        name: "Media Tendency",
        component: MediaTendency,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS TRUST METTER
      {
        path: "/trust-meter",
        name: "Trust Meter",
        component: Trustmetter,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS TRENDING ANALYTICS
      {
        path: "/trending-analysis",
        name: "Trending Analysis",
        component: Trendinganalysis,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS NARASUMBER
      {
        path: "/narasumber",
        name: "Narasumber",
        component: Narasumber,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS QUOTE EXTRACTION
      {
        path: "/quote",
        name: "Quote Extraction",
        component: QuoteExtraction,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS BOT DETECTION
      {
        path: "/bot-detection",
        name: "BotDetection",
        component: BotDetection,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS TOP 10 Mentions
      {
        path: "/top10-mentions",
        name: "Top10Mentions",
        component: Top10Mentions,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS Kecenderungan Akun Dan Media
      {
        path: "/account-integrity",
        name: "AccountIntegrity",
        component: AccountIntegrity,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TRENDING TWITTER
      {
        path: "/twitter-trending",
        name: "Twitter Trending",
        component: TwitterTrending,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TRENDING GOOGLE
      {
        path: "/google-trends",
        name: "Google Trends",
        component: GoogleTrending,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TRASHBIN
      {
        path: "/trashbin",
        name: "TrashBin",
        component: TrashBin,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SETTINGS KEYWORD
      {
        path: "/setting-keyword",
        name: "Keyword",
        component: Keyword,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS USER
      {
        path: "/setting-users",
        name: "Users",
        component: Users,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS CHANNEL
      {
        path: "/setting-channel",
        name: "Channel",
        component: Channel,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS MEDIA
      {
        path: "/setting-media",
        name: "Media",
        component: Media,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTINGS MEDIA
      {
        path: "/crawl-manual",
        name: "Crawl",
        component: Crawl,
        meta: {
          requiresAuth: true,
          permission: [1, 2],
        },
      },
      // PROFILE
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // DETAIL AKUN
      {
        path: "/detail-akun",
        name: "DetailAkun",
        component: DetailAkun,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TESTING INLINE EDIT TABLE
      {
        path: "/coba-inline-edit",
        name: "CobaSimpleTable",
        component: () => import("../views/pages/CobaSimpleTable.vue"),
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
    ],
    get children() {
      return this._children;
    },
    set children(value) {
      this._children = value;
    },
  },
  // MAIN LAYOUT
  {
    path: "/",
    name: "LayoutNoAuth",
    component: NoAUthMainLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "/view",
        name: "View",
        component: View,
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  // LOGIN
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  // ERROR 404
  { path: "*", name: "Error404", component: PageNotFound },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.matched.some((record) => record.meta.permission)) {
        let user_role;
        if (store.getters.token) {
          let token_decode = VueJwtDecode.decode(store.getters.token);
          user_role = token_decode.role;
        } else {
          user_role = store.getters.user.role;
        }

        if (to.meta.permission.includes(user_role)) {
          next();
          return;
        } else {
          next("/login");
          return;
        }
      }
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
